import { 
    createUser, 
    getUsers, 
    getUsersByStoreId, 
    getUsersByStoreIdV2, 
    deleteUser, 
    updateUser,
    findMasterUsersByClientId,
    createMasterUser,
    updateMasterUser,
    deleteMasterUser
 } from '../services/Api';

const insertUser = async ( userData ) => {
    try {
        const response = await createUser( userData );
        return response;
    } catch (err) {
        console.log(`Error to save users: ${err}`)
        return null;
    }
};

const getUsersFromDatabase = async () => {
    try {
        const response = await getUsers();
        return response;
    } catch (err) {
        console.log(`Error to get users: ${err}`)
        return null;
    }
};

const getUsersByStore = async ( storeId ) => {
    try {
        const response = await getUsersByStoreId( storeId );
        return response;
    } catch (err) {
        console.log(`Error to get users: ${err}`)
        return null;
    }
};

const getUsersByStoreV2 = async ( storeId ) => {
    try {
        const response = await getUsersByStoreIdV2( storeId );
        return response;
    } catch (err) {
        console.log(`Error to get users: ${err}`)
        return null;
    }
};

const deleteUserFromDatabase = async ( userId ) => {
    try {
        const response = await deleteUser( userId );
        return response;
    } catch (err) {
        console.log("err to delete user "+ err)
        return null;
    }
};

const editUserFromDatabase = async ( userData ) => {
    try {
        const response = await updateUser(userData);
        return response;
    } catch (err) {
        console.log("err to edit user "+ err)
        return null;
    }
};

// MASTER USER FUNCTIONS

const getMasterUsersByClientId = async (clientId) => {
    try {
        const response = await findMasterUsersByClientId(clientId);
        return response;
    } catch (err) {
        console.log(`Error to get users: ${err}`)
        return null;
    }
};

const insertMasterUser = async (clientId, userData) => {
    try {
        const response = await createMasterUser(clientId, userData);
        return response;
    } catch (err) {
        console.log(`Error to save users: ${err}`)
        return null;
    }
};

const editMasterUserFromDatabase = async (clientId, userData) => {
    try {
        const response = await updateMasterUser(clientId, userData);
        return response;
    } catch (err) {
        console.log("err to edit user "+ err)
        return null;
    }
};

const deleteMasterUserFromDatabase = async (clientId, userId) => {
    try {
        const response = await deleteMasterUser(clientId, userId);
        return response;
    } catch (err) {
        console.log("err to delete user "+ err)
        return null;
    }
};

export {
    insertUser,
    getUsersFromDatabase,
    getUsersByStore,
    getUsersByStoreV2,
    deleteUserFromDatabase,
    editUserFromDatabase,
    getMasterUsersByClientId,
    insertMasterUser,
    editMasterUserFromDatabase,
    deleteMasterUserFromDatabase
}